import { useContext, useEffect, useState } from "react";
import { UserReducerActionType } from "./reducers/userReducer";
import { UserContext } from "./contexts/UserContext";
import { CONSTANT } from "./utils/constants";
import { useAsyncPOSTText } from "./utils/fetchUtils";
import { removeStoreItem } from "./utils/storageUtils";

const LogoutPage = () => {
  const [data, setData] = useState("");
  const { userDispatch } = useContext(UserContext);

  useEffect(() => {
    (async () => {
      const htmlString = await useAsyncPOSTText(`${CONSTANT.URL.API}/${CONSTANT.API.LOGOUT}`, null);
      if(htmlString instanceof Error) {
        setData("An error occured, please try again later.");
      } else {
        if(htmlString !== "{}") {
          userDispatch({ type: UserReducerActionType.CLEAR_USER_INFO, payload: {} });
          removeStoreItem("userInfo");
          // removeStoreItem("cookiePref");
          setData(htmlString);
        } else {
          setData("An error occured, please try again later.");
        }
      }
    })();
  }, []);

  useEffect(() => {
    const button = document.getElementById("SAMLSubmitButton");
    button ? button.click() : null;
  }, [data]);

  return (
    <>
      { data ? <div dangerouslySetInnerHTML={ { __html: data } } /> : null }
    </>
  );
};

export default LogoutPage;
